// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label[data-v-489697e5]{height:15px;width:100px;border-radius:7px}`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/detailscontent/Labels.vue"],"names":[],"mappings":"AACA,wBACE,WAAA,CACA,WAAA,CACA,iBAAA","sourcesContent":["\r\n.label {\r\n  height: 15px;\r\n  width: 100px;\r\n  border-radius: 7px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
